export default defineNuxtRouteMiddleware((to) => {
  // skip middleware on server
  if (import.meta.server) return

  const { isAuthenticated } = useUser()
  const login = useLogin()
  const localePath = useLocalePath()

  if (!isAuthenticated.value) {
    if (isFINQHouston()) {
      return navigateTo(localePath("/auth"))
    } else {
      login.open({ success: () => navigateTo(to) }, "signup")
      return navigateTo(localePath({ name: "index" }))
    }
  }
})
